import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as R from 'ramda'

import {
  getAccounts,
  getCurrentAccount,
  getLanguage,
  getUser,
  logOut,
  setLanguage,
  switchAccount,
} from 'ducks/auth'
import { getLanguages } from 'utils/languages'

const useUserProfileMutations = () => {
  const dispatch = useDispatch()

  const handleLogOut = React.useCallback(() => {
    dispatch(logOut())
  }, [dispatch])

  const handleSwitchAccount = React.useCallback(
    ({ id }) => {
      dispatch(switchAccount(id))
    },
    [dispatch],
  )

  const handleSwitchLanguage = React.useCallback(
    ({ code }) => {
      dispatch(setLanguage(code))
    },
    [dispatch],
  )

  return {
    handleLogOut,
    handleSwitchAccount,
    handleSwitchLanguage,
  }
}

const useUserProfileData = () => {
  const accounts = useSelector(getAccounts)
  const account = useSelector(getCurrentAccount)
  const language = useSelector(getLanguage)
  const user = useSelector(getUser)

  const languages = getLanguages()

  const name = user?.pk ? `${user?.first_name} ${user?.last_name}` : 'Anonymous'
  const companyName = R.prop(
    'name',
    R.find(R.propEq('id', user?.active_account), user?.accounts),
  )

  return {
    state: {
      accounts,
      activeAccount: account?.id,
      activeLanguage: language,
      languages,
      user: { ...user, name, companyName },
    },
  }
}

export const useUserProfile = () => {
  const {
    handleLogOut,
    handleSwitchAccount,
    handleSwitchLanguage,
  } = useUserProfileMutations()

  const {
    state: { accounts, activeAccount, activeLanguage, languages, user },
  } = useUserProfileData()

  const handleClickAdmin = () => {
    window.location.pathname = '/admin/'
  }

  return {
    state: { accounts, activeAccount, activeLanguage, languages, user },
    handlers: {
      handleClickAdmin,
      handleLogOut,
      handleSwitchAccount,
      handleSwitchLanguage,
    },
  }
}
